import { render, staticRenderFns } from "./TableWidget.vue?vue&type=template&id=b4a3e10e&scoped=true&"
import script from "./TableWidget.vue?vue&type=script&lang=js&"
export * from "./TableWidget.vue?vue&type=script&lang=js&"
import style0 from "./TableWidget.vue?vue&type=style&index=0&id=b4a3e10e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a3e10e",
  null
  
)

export default component.exports